import React from "react";
import { Modal } from "antd";
import { selectedPolygonTypes } from "../Common/Constants";
import PopulationGridContent from "./PopulationGridContent";
import DailyTrafficContent from "./DailyTrafficContent";
const {
	PopulationGrids,
	DailyTrafficData,
	motor_spots,
	digitalPersona,
	TargetedConsumer,
	demographicPopulationDensity
} = selectedPolygonTypes;
export const PolygonsModal = ({ isVisible, onClose, polygon, polygonType }) => {
	return (
		<Modal
			title={`Polygon Details`}
			open={isVisible}
			onCancel={() => onClose()}
			footer={[]}
			width={[DailyTrafficData, motor_spots].includes(polygonType) ? 1500 : 700}
		>
			{/* {polygonType === PopulationGrids && <PopulationGridContent isVisible={isVisible} polygon={polygon} />} */}
			{[DailyTrafficData, motor_spots].includes(polygonType) && (
				<DailyTrafficContent isVisible={isVisible} polygon={polygon} />
			)}

			{polygonType === PopulationGrids && (
				<PopulationGridContent isVisible={isVisible} polygon={polygon} viewGoogleMap />
			)}

			{polygonType === TargetedConsumer && (
				<PopulationGridContent isVisible={isVisible} polygon={polygon} viewGoogleMap />
			)}
			{polygonType === digitalPersona && (
				<PopulationGridContent isVisible={isVisible} polygon={polygon} viewGoogleMap />
			)}

			{polygonType === demographicPopulationDensity && (
				<PopulationGridContent isVisible={isVisible} polygon={polygon} viewGoogleMap />
			)}
		</Modal>
	);
};

export default PolygonsModal;
